import { NavLink } from 'react-router-dom';
import { useTheme } from '../theme/useTheme';

export function Topbar({ breadcrumb = 'Dashboard' }: { breadcrumb?: string }) {
  const { isLight, toggle } = useTheme();

  return (
    <header className="topbar">
      <div className="topbar-breadcrumb">
        <span>MatériaPrimAi Eventos</span>
        <i className="ti ti-chevron-right" style={{ fontSize: 12 }} />
        <span className="current">{breadcrumb}</span>
      </div>

      {/* A busca global do kit visual saiu daqui: não existia backend para ela,
          e um campo que não busca nada é pior que campo nenhum. Cada listagem
          tem a sua própria, que funciona. */}
      <div style={{ flex: 1 }} />

      <div className="topbar-actions">
        <button className="icon-btn" title="Tema" onClick={toggle}>
          <i className={`ti ${isLight ? 'ti-moon' : 'ti-sun'}`} style={{ fontSize: 16 }} />
        </button>
        <NavLink className="icon-btn" to="/conta" title="Minha conta">
          <i className="ti ti-user-circle" style={{ fontSize: 16 }} />
        </NavLink>
      </div>
    </header>
  );
}
